import { ChannelState } from '../../enums/channel-state.enum';
import CycleMeasurement from '../../enums/cycle-measurement';

export const TEMPERATURE_ZONE = {
  [CycleMeasurement.Fahrenheit]: {
    EXTREME_COLD: { MIN: -Infinity, MAX: -30, COLOR: 'bg-electric-indigo' },
    VERY_COLD: { MIN: -30, MAX: -15, COLOR: 'bg-skyline-blue' },
    NEUTRAL: { MIN: -15, MAX: 15, COLOR: '' },
    WARM: { MIN: 15, MAX: 30, COLOR: 'bg-rose-400' },
    HOT: { MIN: 30, MAX: Infinity, COLOR: 'bg-red' },
  },
  [CycleMeasurement.Celsius]: {
    EXTREME_COLD: { MIN: -Infinity, MAX: -16, COLOR: 'bg-electric-indigo' },
    VERY_COLD: { MIN: -16, MAX: -8, COLOR: 'bg-skyline-blue' },
    NEUTRAL: { MIN: -8, MAX: 8, COLOR: '' },
    WARM: { MIN: 8, MAX: 16, COLOR: 'bg-rose-400' },
    HOT: { MIN: 16, MAX: Infinity, COLOR: 'bg-red' },
  },
};

export const SKIP_SYMBOL = '-';
export const COLOR_FOR_EMPTY_IOT = '#808080'; // Gray
export const THERMOCOUPLE_STATE = 0;
export const STATE_COLORS = {
  [THERMOCOUPLE_STATE]: COLOR_FOR_EMPTY_IOT,
  [ChannelState.RUNNING]: '#008000', // Green
  [ChannelState.PAUSED]: '#EF8541', // Orange
  [ChannelState.STOPPED]: '#0000ff', // Blue
  [ChannelState.FAULTED]: '#ff0000', // Red
};

export const BG_STATE_COLORS = {
  [THERMOCOUPLE_STATE]: COLOR_FOR_EMPTY_IOT,
  [ChannelState.RUNNING]: 'bg-green-100', // Green
  [ChannelState.PAUSED]: 'bg-orange-100', // Orange
  [ChannelState.STOPPED]: 'bg-blue-100', // Blue
  [ChannelState.FAULTED]: 'bg-rose-100', // Red
};

// Lighter/darker shade pairs of the same state colors, so rows stay zebra-striped
// (and therefore distinguishable from one another) even while running/paused/faulted.
export const BG_STATE_COLORS_ZEBRA = {
  [THERMOCOUPLE_STATE]: { light: COLOR_FOR_EMPTY_IOT, dark: COLOR_FOR_EMPTY_IOT },
  [ChannelState.RUNNING]: { light: 'bg-green-100', dark: 'bg-green-200' }, // Green
  [ChannelState.PAUSED]: { light: 'bg-orange-100', dark: 'bg-orange-200' }, // Orange
  [ChannelState.STOPPED]: { light: 'bg-blue-100', dark: 'bg-blue-200' }, // Blue
  [ChannelState.FAULTED]: { light: 'bg-rose-100', dark: 'bg-rose-200' }, // Red
};

export const EMPTY_IOT_CHANNEL = {
  channel: SKIP_SYMBOL,
  mlis: SKIP_SYMBOL,
  mode: SKIP_SYMBOL,
  oc: SKIP_SYMBOL,
  po: SKIP_SYMBOL,
  ser: SKIP_SYMBOL,
  serial: SKIP_SYMBOL,
  sp: SKIP_SYMBOL,
  state: 0,
  stcn: SKIP_SYMBOL,
  t: SKIP_SYMBOL,
  temp: SKIP_SYMBOL,
};
export const EMPTY_IOT_THERMOCOUPLE = {
  thermocouple: SKIP_SYMBOL,
  mlis: SKIP_SYMBOL,
  mode: SKIP_SYMBOL,
  oc: SKIP_SYMBOL,
  po: SKIP_SYMBOL,
  ser: SKIP_SYMBOL,
  serial: SKIP_SYMBOL,
  sp: SKIP_SYMBOL,
  state: 0,
  stcn: SKIP_SYMBOL,
  t: SKIP_SYMBOL,
  temp: SKIP_SYMBOL,
};
export const EXPIRATION_TIME_MS = 2 * 60 * 1000; // 2min
